import { Link } from "react-router-dom";
import BannerEditor from "../components/admin/BannerEditor";
import Deploys from "../components/admin/Deploys";
import Lambdas from "../components/admin/Lambdas";
import Members from "../components/admin/Members";
import Tables from "../components/admin/Tables";
import Visitors from "../components/admin/Visitors";
import RequireAuth from "../components/RequireAuth";
import type { AdminMode } from "../hooks/useAdminMode";
import type { Session } from "../hooks/useSession";

export default function AdminPage({ session, adminMode }: { session: Session; adminMode: AdminMode }) {
  const { user, signIn } = session;
  return (
    <main className="page admin">
      <h1>Admin</h1>
      <RequireAuth user={user} onSignIn={signIn}>
        {user && adminMode.on ? (
          <>
            <BannerEditor />
            <Members me={user.sub} />
            <Tables />
            <Deploys />
            <Lambdas />
            <Visitors />
          </>
        ) : adminMode.available ? (
          <p className="muted">
            Admin tools are off. Turn them on in <Link to="/account">your account</Link>.
          </p>
        ) : (
          <p className="muted">
            This page is for Salvagers admins. If you were just made one, sign out and back in so your sign-in picks it
            up.
          </p>
        )}
      </RequireAuth>
    </main>
  );
}
